import React, { useState } from 'react'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Dialog } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { createQuiz } from '../api/index'
import { useSelector, shallowEqual } from 'react-redux';
import { UseImageUpload } from '../../../hooks/UseImageUpload';

export const Settings = ({ setQuizButtonText, setCouponCode, highestPrice, quiz, fetch, setQuizTitle, setQuizDescription, goToMainQuizPage, children, updateBackgroundImage }) => {
    const [from, setFromTs] = useState(quiz.from || Date())
    const [to, setToTs] = useState(quiz.to || nextweek())
    const [tempToDate, setTempToDate] = useState(0)
    const [confirmationModal, setConfirmationModal] = useState(false);
    function nextweek() {
        const today = new Date();
        const nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
        return nextweek;
    }
    const { merchantId } = useSelector(
        (state) => ({
            merchantId: state.merchants.filter.merchantId,
        }),
        shallowEqual
    );

    function changeFromDate(params) {
        setFromTs(Date.parse(params))
    }
    function changeToDate(params) {
        if (Date.now() > Date.parse(params)) {
            setTempToDate(Date.parse(params))
            return setConfirmationModal(true)
        }
        setToTs(Date.parse(params))
    }

    function canPublishQuiz() {
        return from && to && quiz.title && quiz.body;
    }

    async function publish() {
        quiz.to = to;
        quiz.from = from;
        quiz.merchantId = merchantId;
        await createQuiz({ quiz, highestPrice })
        goToMainQuizPage()
        fetch(merchantId)
    }

    function confirmToDate() {
        setToTs(tempToDate)
        setConfirmationModal(false)
    }
    const textInputs = [
        {
            text: 'Title',
            onInput: setQuizTitle,
            defaultValue: quiz.title,
            placeholder: 'Quiz Title',
        },
        {
            text: 'Description',
            onInput: setQuizDescription,
            defaultValue: quiz.body,
            placeholder: 'Quiz Description',
        },
        {
            text: 'Button Text',
            onInput: setQuizButtonText,
            defaultValue: quiz.button,
            placeholder: 'Button Text',
        },
        {
            text: 'Coupon Code',
            onInput: setCouponCode,
            defaultValue: quiz.couponCode,
            placeholder: 'Coupon Code (optional)',
        },
    ];
    return (
        <div style={{
            backgroundColor: 'white',
            padding: '24px',
            width: '468px',
        }}>
            {textInputs.map(input =>
                <div>
                    <h3>{input.text}</h3>
                    <input onInput={input.onInput} defaultValue={input.defaultValue} className="mb-6 form-control form-control-solid" placeholder={input.placeholder} />
                </div>
            )}
            <div className='mb-6'>
                <h3>Background Picture</h3>
                <UseImageUpload imageObj={quiz} afterImageUpload={updateBackgroundImage} />
            </div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    name='from'
                    disableToolbar
                    variant='inline'
                    format='MM/dd/yyyy'
                    label='From'
                    disablePast={!quiz.from}
                    value={from}
                    onChange={changeFromDate}
                    minDate={quiz.from ? '' : Date()}
                    required
                    style={{ marginRight: 12, width: `calc(50% - 6px)` }}
                />
                <KeyboardDatePicker
                    value={to}
                    name='to'
                    disableToolbar
                    variant='inline'
                    format='MM/dd/yyyy'
                    label='To'
                    onChange={changeToDate}
                    required
                    style={{ width: `calc(50% - 6px)` }}
                />
            </MuiPickersUtilsProvider>
            <Dialog open={confirmationModal}
                onBackdropClick={() => setConfirmationModal(false)}
            >
                <div style={{ width: '400px', }} className="modal position-relative d-block" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">The end date selected is lower than the current date</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <i aria-hidden="true" className="ki ki-close"></i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to continue?</p>
                            </div>
                            <div className="modal-footer">
                                <button onClick={() => setConfirmationModal(false)} type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button onClick={confirmToDate} type="button" className="btn btn-primary">Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {children}
            <div style={{ float: 'right' }}>
                {/* <button onClick={() => sendQuizPreview(quiz)} style={{ borderRadius: '8px', display: 'block' }} type="button" className="btn btn-light-dark font-size-h6 my-3">
                    Preview
                </button> */}
                <button onClick={publish} disabled={!canPublishQuiz} style={{ borderRadius: '8px', display: 'block' }} type="button" className="btn btn-dark font-size-h6 my-3">
                    Publish
                </button>
            </div>
        </div >
    )
}
